import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';

import OneVisualLayout from '../../layouts/one-visual';

import Image from '../../../../../containers/assets/instructor-successful-teams2.png'

class SuccessfulStep2 extends PureComponent {
  render() {
    return (
      <OneVisualLayout
        section="Successful Teams"
        title="Reason Why Teams Hit Their Targets"
        paragraph1={(
          <Fragment>
            <p>Teams that were successful in Round 2 did 3 things very well . They 1) reviewed their feedback, 2) performed competitive analysis, and then 3) offered a greater value proposition.</p>
            <p>To better understand their competitive position, these teams likely spend sometime evaluating the marketing analysis section of the Team Report. They then leverage those insights to make their products more attractive.</p>
            <p>To further enhance their value proposition, they likely selected a distribution center that offered the best lead time to delivery.</p>
          </Fragment>
        )}
        visual={(
          <img src={Image} alt='Distribution Centers' />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }
}

export default SuccessfulStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/successful-teams/step2.js